import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { AccountExternalLinks } from '../types/account';

// ONE read of every account's external link slice for the page (round 2 item
// 3), shared by every <AccountLinkIcons accountId=…> on it via one react-query
// key. Carry it on the list when every row needs it; read it once for the page
// when many places need the same small thing — rather than widening six more
// surfaces' projections, each of which could silently drop a field.
//
// 30-minute staleTime: these are hand-entered URLs that barely move.

export const ACCOUNT_LINKS_QUERY_KEY = ['account-links'] as const;
const ACCOUNT_LINKS_STALE_MS = 30 * 60 * 1000;

export async function fetchAccountLinks(): Promise<Record<string, AccountExternalLinks>> {
  const res = await api<{ links: Record<string, AccountExternalLinks> }>('/api/accounts/links');
  return res.links;
}

export function useAccountLinks() {
  return useQuery({
    queryKey: ACCOUNT_LINKS_QUERY_KEY,
    queryFn: fetchAccountLinks,
    staleTime: ACCOUNT_LINKS_STALE_MS,
  });
}
